module.exports = __webpack_public_path__ + "static/img/top-banner1-t.673b90f.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/top-banner1-t.png
// module id = d6b4
// module chunks = 1